import axios from 'axios'
import Loading from 'vue-loading-overlay'
import * as config from '@/config.json'
export default {
  name: 'LoginComp',
  components: {
    Loading
  },
  data() {
    return {
      isLoading: false,
      email: '',
      password: '',
      passwordVisible: true
    }
  },
  methods: {
    async resetPassword() {
      if (!this.email) {
        await this.$alert('É obrigatório informar o e-mail para solicitar a alteração de senha.', 'Aviso', 'warning')
        return
      }

      this.isLoading = true
      const data = {
        email: this.email
      }

      const url = `${config.default.urlBase}/users/reset-password`

      try {
        const response = await axios({
          url: url,
          method: 'post',
          data,
          headers: {
            authorization: config.default.autorizationRetailer
          }
        })

        if (response.status == 200) {
          this.isLoading = false
          await this.$alert(`Solicitação de alteração de senha enviada para o e-mail ${this.email}!`, 'Sucesso', 'success')
        }
      } catch (error) {
        console.log({
          error
        })

        this.isLoading = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        } else if (error.response.status == 400) {
          await this.$alert(error.response.data.message, 'Erro', 'error')
        } else if (error.response.status == 404) {
          await this.$alert(
            'E-mail não localizado, não será possível realizar a alteração de senha! Verifique o e-mail informado e tente refazer a solicitação.',
            'Aviso',
            'warning'
          )
        } else if (error.response.status == 403) {
          await this.$alert('Acesso negado. Verifique a configuração da API ou entre em contato com o suporte.', 'Erro', 'error')
        } else if (error.response.status == 500) {
          const msg = error.response.data?.message || 'Erro interno no servidor. Tente novamente mais tarde ou entre em contato com o suporte.'
          await this.$alert(msg, 'Erro', 'error')
        } else {
          await this.$alert('Ocorreu um erro inesperado. Tente novamente ou entre em contato com o suporte.', 'Erro', 'error')
        }
      }
    },

    showPassword() {
      let pass = document.getElementById('password')

      if (pass.type == 'password') {
        pass.type = 'text'
      } else {
        pass.type = 'password'
      }

      this.passwordVisible = !this.passwordVisible
      this.focus('password')
    },

    focus(id) {
      document.getElementById(id).focus()
    },

    async login() {
      const data = {
        email: this.email,
        password: this.password
      }

      const url = `${config.default.urlBase}/users/login`

      try {
        const response = await axios({
          url,
          method: 'post',
          data
        })

        if (response.status == 200) {
          // Dados essenciais salvos no sessionStorage
          sessionStorage.setItem('token', response.data.token)
          sessionStorage.setItem('logado', true)
          sessionStorage.setItem('permissions', JSON.stringify(response.data.permissions))

          // Dados do usuário logado
          sessionStorage.setItem('typeUser', response.data.user.id)
          sessionStorage.setItem('idUsuarioLogado', response.data.user.id)
          sessionStorage.setItem('usuarioLogado', response.data.user.name)
          sessionStorage.setItem('typeUser', response.data.user.type)
          sessionStorage.setItem('divisionId', response.data.user.divisionId)
          sessionStorage.setItem('divisionName', response.data.user.divisionName)

          // Dados adicionais do usuário para o perfil
          sessionStorage.setItem('userEmail', response.data.user.email || '')
          sessionStorage.setItem('userPhone', response.data.user.phone || '')
          sessionStorage.setItem('userIsSlackNotify', response.data.user.isSlackNotify)
          sessionStorage.setItem('userIsTelegramNotify', response.data.user.isTelegramNotify)
          sessionStorage.setItem('userIsAppNotify', response.data.user.isAppNotify)
          sessionStorage.setItem('userIsWhatsAppNotify', response.data.user.isWhatsAppNotify)

          this.$router.push('home')
        }
      } catch (error) {
        console.log({
          error
        })

        this.isLoading = false
        this.focus('email')

        sessionStorage.setItem('logado', false)

        if (error.message == 'Network Error') {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        } else if (error.response.status == 401) {
          this.$alert(`${error.response.data.message}`, 'Aviso', 'warning')
        } else {
          await this.$alert('Usuário ou senha incorreto!', 'Erro', 'error')
        }
      }
    },

    clearEmail() {
      this.email = ''
      this.focus('email')
    },

    clearlocalStorage() {
      sessionStorage.removeItem('idUsuarioLogado')
      sessionStorage.removeItem('usuarioLogado')
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('typeUser')
      sessionStorage.removeItem('divisionId')
      sessionStorage.removeItem('divisionName')
      sessionStorage.removeItem('userEmail')
      sessionStorage.removeItem('userPhone')
      sessionStorage.removeItem('userIsSlackNotify')
      sessionStorage.removeItem('userIsTelegramNotify')
      sessionStorage.removeItem('userIsAppNotify')
      sessionStorage.removeItem('userIsWhatsAppNotify')

      sessionStorage.setItem('logado', false)
    }
  },

  async beforeMount() {
    this.isLoading = true
    await this.clearlocalStorage()
    this.isLoading = false
  }
}
